export const MEDIA_DOMAIN = 'media'

export const MEDIA_KEY = {
  ALL: 'all',
  DATA: 'data',
  CURRENT: 'current'
}

export const MEDIA_PATH = {
  ALL: `${MEDIA_DOMAIN}.${MEDIA_KEY.ALL}`,
  ALL_DATA: `${MEDIA_DOMAIN}.${MEDIA_KEY.ALL}.data`,
  DATA: `${MEDIA_DOMAIN}.${MEDIA_KEY.DATA}`,
  CURRENT: `${MEDIA_DOMAIN}.${MEDIA_KEY.CURRENT}`
}

export const MEDIA_STATE = {
  [MEDIA_KEY.ALL]: {
    data: [],
    status: null
  },
  [MEDIA_KEY.CURRENT]: null,
  [MEDIA_KEY.DATA]: {}
}

export const MEDIA_ANALYTICS_EVENT = {
  CREATED: 'Chat Created',
  CLOSED: 'Chat Closed',
  LINK_PRESSED: 'Chat Link Pressed',
  REPLY_ADDED: 'Chat Reply Added',
  DELETED: 'Chat Deleted'
}

export const MEDIA_ACTION = {
  CREATE: 'MEDIA_CREATE',
  CLOSE: 'MEDIA_CLOSE',
  LOAD: 'MEDIA_LOAD',
  LOAD_BY_ID: 'MEDIA_LOAD_BY_ID',
  SAVE: 'MEDIA_SAVE',
  UPDATE_CURRENT: 'MEDIA_UPDATE_CURRENT',
  DELETE: 'MEDIA_DELETE'
}

const ROOT = '/media'
export const MEDIA_ENDPOINT = {
  ROOT
}
